'use client'

import { useEffect } from 'react'
import { AppErrorState } from '@/components/app-error-state'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('[AppError]', error)
  }, [error])

  return (
    <AppErrorState
      eyebrow="Application error"
      title="Something went wrong"
      message="The app hit an unexpected error while loading this page. Try again first; if it repeats, go back to the CRM home screen."
      onReset={reset}
    />
  )
}
